import { defineRecipe } from '@plurall/elo-v3';

export const navSectionRecipe = defineRecipe({
  className: 'group',
  base: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    marginBlockEnd: 'var(--spc-2xsmall)',
    transitionProperty: 'margin-block-end',
    transitionDuration: '.3s',
    transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.18, 1)',
    '.local-navigation[data-open="true"] &, .local-navigation[data-open="false"]:hover &': {
      marginBlockEnd: 0,
      sm: {
        marginBlockEnd: 'padding.3xlarge',
      },
    },
  },
});

export const navSectionTitleRecipe = defineRecipe({
  className: 'group__title',
  base: {
    fontSize: 'font.size.xsmall',

    interpolateSize: 'allow-keywords',
    blockSize: 'auto',
    paddingBlock: '0',
    paddingInline: 'padding.small',
    margin: '0',
    marginBlockEnd: 'padding.3xsmall',
    fontWeight: '700',
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    color: 'var(--sidebar-text-color)',
    minInlineSize: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    transitionProperty: 'block-size, display',
    transitionBehavior: 'allow-discrete',
    transitionDuration: '.15s',
    transitionDelay: '.3s',
    transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.18, 1)',

    '[data-open="false"]:not(:hover) &': {
      blockSize: '0',
      display: 'none',
      transition: 'none',
    },
  },
});

export const navSeparatorRecipe = defineRecipe({
  className: 'group__divider',
  base: {
    display: 'block',
    inlineSize: 'auto',
    minInlineSize: '0',
    borderTop: '1px solid var(--sidebar-divider-color)',
    marginBlock: 'padding.large',
    marginInline: 'padding.small',
    opacity: '1',
    transitionProperty: 'margin-block, opacity',
    transitionDuration: '.15s',
    transitionTimingFunction: 'ease-in-out',
    '.local-navigation[data-open="true"] &, .local-navigation[data-open="false"]:hover &': {
      marginBlock: '0',
      opacity: '0',
    },
  },
});

export const navItemRecipe = defineRecipe({
  className: 'nav-item',
  base: {
    display: 'grid',
    width: '100%',
    minWidth: 0,
    listStyle: 'none',
  },
  variants: {
    isCollapsedRail: {
      true: { placeItems: 'center' },
      false: {},
    },
  },
  defaultVariants: { isCollapsedRail: false },
});

export const navLoadingItemRecipe = defineRecipe({
  className: 'local-navigation__item--loading',
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '4rem',
  },
});

export const navSectionItemsRecipe = defineRecipe({
  className: 'nav-section-items',
  base: {
    display: 'grid',
    gap: 'space.2',
    width: '100%',
    minWidth: 0,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  variants: {
    align: {
      stretch: { justifyItems: 'stretch' },
      center: { justifyItems: 'center' },
    },
  },
  defaultVariants: { align: 'stretch' },
});
